<!-- <template src="./Plans.html"></template>
<style src="./Plans.scss" lang="scss" scoped></style>
<script src="./Plans.js"></script> -->
<template>
    <div></div>
</template>

<script>
export default {
    name: 'Plans',
    created() {
        this.$router.push({ name: 'CompetitionDashboardGuest', params: { openPlansModal: true } });
    }
};
</script>

<style></style>
